import React from 'react';
import styled, { css } from 'styled-components';
import { black, screenSmMin, spacer16, Type, } from '@spotify-internal/encore-web';
import { DELAYS, fadeInAnimation, withAnimationContext, } from '../../../ui';
import { HeroLayout } from '../HeroLayout';
const getBurst = (color = black, layout) => {
    return css `
    background-image: url("
      data:image/svg+xml,%3Csvg
      width='1331'
      height='551'
      viewBox='0 0 1331 551'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'%3E%3Cpath
      d='M0.5 510.5L635.622 2L552.339 244.523L710.022 145.501L603.975 549L1330.5 130.5'
      stroke='%23${color.substring(1)}'/%3E%3C/svg%3E
    ");
    background-size: cover;
    background-repeat: no-repeat;
    background-position: bottom 40px
      ${layout === 'imageLeft' ? 'left 0px' : 'right 0px'};
  `;
};
const HeroLayoutWithBurst = styled(HeroLayout) `
  @media (min-width: ${screenSmMin}) {
    ${({ showBurst, colors, layout }) => showBurst ? getBurst(colors.textColor, layout) : ''};
  }
`;
const Supertext = withAnimationContext(styled(Type.p).attrs({
    variant: 'balladBold',
}) `
    ${fadeInAnimation(DELAYS.FIRST)};
    text-transform: uppercase;
    margin-bottom: ${spacer16};
  `);
const Headline = withAnimationContext(styled(Type.h2).attrs({
    variant: 'altoBrio',
}) `
    ${fadeInAnimation(DELAYS.SECOND)};
  `);
export const HeroNarrativeCoverModule = React.forwardRef(({ supertext = '', headline = '', image, layout = 'imageLeft', colors, showBurst = false, }, ref) => {
    return (React.createElement(HeroLayoutWithBurst, { image: image, layout: layout, colors: colors, showBurst: showBurst, ref: ref },
        supertext && React.createElement(Supertext, null, supertext),
        React.createElement(Headline, null, headline)));
});
